import React from "react";

export const App = ({ location, data, children }) => children;
